/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:51
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('PhysicalResourceView',["PhysicalResourceData","PhysicalResourceSrv","PhysicalResource",
        function (PhysicalResourceData,PhysicalResourceSrv,PhysicalResource) {

        let  PhysicalResourceView = function(physicalResource,prIndex,domainView,order) {
            this.prIndex =  prIndex;
            this.domainView = domainView;
            this.label = null;
            this.number = 1;
            this.hasPlanning = true;
            this.onLineBooking = true;
            this.order = null;

            this.display = true;

            if (physicalResource) {
                this.loadDataFrom(physicalResource);
            }

            if(order != undefined && order != null) {
                this.order = order;
            }
        };

        PhysicalResourceView.prototype.loadDataFrom = function(physicalResource) {
            if(physicalResource.id) {
                this.id = physicalResource.id;
            }
            this.label = physicalResource.label;
            this.number = physicalResource.number;
            this.hasPlanning = physicalResource.hasPlanning;
            this.onLineBooking = physicalResource.onLineBooking;
            this.order = physicalResource.order;
        };

        PhysicalResourceView.prototype.copyDataTo = function(physicalResource) {
            physicalResource.label = this.label;
            physicalResource.number = this.number;
            physicalResource.hasPlanning = this.hasPlanning;
            physicalResource.onLineBooking = this.onLineBooking;
            physicalResource.order = this.order;
        };

        PhysicalResourceView.prototype.isChanged = function () {
            let pr = this.getModel();
            if (pr) {
                return (
                    this.label != pr.label ||
                    this.number != pr.number ||
                    this.hasPlanning != pr.hasPlanning ||
                    this.onLineBooking != pr.onLineBooking ||
                    this.order != pr.order
                );
            } else {
                return true;
            }
        };

        PhysicalResourceView.prototype.getModel = function()
        {
            if (this.prIndex!=-1)
                return PhysicalResourceData.getByIndex(this.prIndex);
            return null;
        };

        PhysicalResourceView.prototype.initPrData = function () {
            let physicalResource = this.getModel();
            if (physicalResource == null) {
                physicalResource = new PhysicalResource();
                this.prIndex = PhysicalResourceData.getIndexOf(physicalResource);
            }
            this.copyDataTo(physicalResource);
            return physicalResource;
        };

        PhysicalResourceView.prototype.updateModel = function () {
            if (!this.isChanged()) {
                let physicalResource = this.initPrData();
                PhysicalResourceSrv.save(physicalResource);
            }
        };

        PhysicalResourceView.prototype.updateModelWithPromise = function () {
            let physicalResourceView = this;
            return new Promise((resolve, reject) => {
                if (!physicalResourceView.isChanged()) {
                    return resolve();
                }
                let physicalResource = physicalResourceView.initPrData();
                PhysicalResourceSrv.save(physicalResource, resolve, reject);
            });
        };

        PhysicalResourceView.prototype.reloadModel = function()
        {
            var pr = this.getModel();
            if (pr!=null)
                this.loadDataFrom(pr);
        };
        PhysicalResourceView.prototype.removeModel = function()
        {
            var pr = this.getModel();
            if (pr!=null)
                PhysicalResourceSrv.remove(pr);
        };
        PhysicalResourceView.prototype.restoreModel = function()
        {
            var pr = this.getModel();
            if (pr)
                PhysicalResourceSrv.restore(pr);
        };
        PhysicalResourceView.prototype.knowsServiceView = function(serviceView) {
            if (serviceView) {
                let pr = this.getModel();
                if (pr)
                    return pr.hasService(serviceView.getModel());
            }
            return false;
        };
        PhysicalResourceView.prototype.canSave = function() {
            return (this.number && this.number>0 && this.label && this.label!="")

        };

        return  PhysicalResourceView;
    }
    ]);




// WEBPACK FOOTER //
// ./js/services/views/PhysicalResourceView.js